import styled from 'styled-components';
import { Button } from '~/components/button';
import { Container } from '~/components/layout';

export const Wrapper = styled(Container)`
  border: 1px solid ${props => props.theme.colors.background.tertiary};
  border-radius: 8px;
  flex-direction: column;
  gap: 24px;

  ${props => props.theme.media.tabletLandscapeUp} {
    gap: unset;
    flex-direction: row;
  }
`;

export const ButtonsContainer = styled(Container)`
  display: flex;
  flex-direction: column;
  gap: 16px;
  margin-top: 16px;
  margin-left: 4px;
  min-width: 30%;
  ${props => props.theme.media.tabletLandscapeUp} {
    margin-top: 0;
    margin-left: 0;
  }
`;

export const ShareButton = styled(Button)``;

export const MarkCompletedButton = styled(Button)``;

export const CustomerDetailsContainer = styled(Container)`
  flex-direction: column;

  ${props => props.theme.media.tabletLandscapeUp} {
    flex-direction: row;
  }
`;

export const NameContainer = styled(Container)``;

export const ContactInfoContainer = styled(Container)`
  margin-top: 8px;
  overflow: scroll;

  ${props => props.theme.media.tabletLandscapeUp} {
    margin-top: 0;
  }
`;
